export default {
      id: "oc-cancel-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-cancel",
      toString: function () {
        return this.url;
      }
    }